import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  ONYX_TABLE_TOOLTIP_DELAY,
  OnyxLanguagePipe,
  OnyxTemperaturePipe,
  OnyxTooltipDirective,
  OverflowHelper,
} from '@onyx/angular';
import type { Fleet } from '../../../../dashboard/fleet/common/interfaces/fleet';
import type { Order } from '../../../../dashboard/orders/common/interfaces/order';
import { DictionaryCode } from '../../../enums/dictionary-code';
import { CommonHelper } from '../../../helpers/common.helper';
import { JoinPipe } from '../../../pipes/join.pipe';

@Component({
  selector: 'app-parameters-cell',
  imports: [
    TranslatePipe,
    OnyxTemperaturePipe,
    OnyxLanguagePipe,
    OnyxTooltipDirective,
    NgTemplateOutlet,
    JoinPipe,
  ],
  templateUrl: './parameters-cell.component.html',
  styleUrl: './parameters-cell.component.scss',
})
export class ParametersCellComponent {
  private readonly translateService = inject(TranslateService);

  public readonly additionalParameters = input.required<
    Fleet['additionalParameters'] | Order['parameters']
  >();
  public readonly visibleParametersCount = input<number | null>(2);

  protected readonly I18N = 'fleet.fleetList.cells.parameters.';
  protected readonly TOOLTIP_DELAY = ONYX_TABLE_TOOLTIP_DELAY;

  protected readonly DictionaryCode = DictionaryCode;
  protected readonly OverflowHelper = OverflowHelper;

  protected parameters = computed(() =>
    CommonHelper.getSortedParameters(
      this.additionalParameters(),
      this.translateService,
    ),
  );
  protected visibleParameters = computed(() => {
    const count = this.visibleParametersCount();
    return count ? this.parameters().slice(0, count) : this.parameters();
  });
}
